export default {
  order: {
    navList: {
      navitem1: 'All Orders',
      navitem2: 'Pending Confirmation',
      navitem3: 'Pending Payment',
      navitem4: 'Pending Shipment',
      navitem5: 'Pending Preparation',  // Alternative: "Processing" for warehouse ops
      navitem6: 'Pending Delivery',
      navitem7: 'Pending Pickup',
      navitem8: 'Completed',
      navitem9: 'Cancelled',
    },
    table: {
      step1: 'Order No.',
      step2: 'Payment Deadline',
      step3: 'Delivery Deadline',
      step4: 'Specs:',
      step5: 'View More Items',
      step6: 'Grand Total',
      step7: 'Includes',
      step8: 'Shipping Fee',
      step9: 'Order Info',
      step10: 'Total',
      step11: 'Status',
      step12: 'Action',
      step13:'Negotiable'
    },
    msgState: {
      msg1: 'Balance Unpaid',
      msg2: 'Awaiting Merchant Review',
      msg3: 'Track Progress',
      msg4: 'Please pick up at designated location',
      msg5:'Product Name/Order Number',
      msg6:'No logistics information available at the moment'

    },
    btnState: {
      btn1: 'Confirm Receipt',
      btn2: 'Cancel Order',
      btn3: 'Confirm Pickup',
      btn4: 'Delete Order',
      btn5: 'Order Details',
      btn6: 'Cancel Order',  // Duplicate intentional?
      btn7: 'Pay Now',
      btn8: 'After-sales Details',
      btn9: 'Request Refund',
      btn10: 'Pay Balance',
    },
    dialogState: {
      dil1: 'Cancelled orders cannot be restored. Coupons will not be refunded. Paid amounts will be returned to original payment method after review.',
      dil2: 'Cancel Order',
      dil3: 'Order Tracking',
      dil4: 'Parcel',
      dil5: 'Logistics Provider',
      dil6: 'Tracking No.',
      dil7: 'Package',  // Alternative to "Parcel" for consistency
      dil8: 'Reconsider',
      dil9: 'Submit'
    },
    confirmState: {
      confirm1: 'Notification',
      confirm2: 'Confirm',
      confirm3: 'Cancel',
      confirm4: 'Cancelled',
      confirm5: 'Delete this order?',
      confirm6: 'Order deleted!',
      confirm7: 'Confirm goods received in good condition per acceptance criteria?',
      confirm8: 'Receipt confirmed!',
      confirm9: 'Order cancelled',
      confirm10: 'Confirm product inspection dispute?',
    }
  }
}